import { InspectionOrder, InspectionOrderItem, InspectionProgress } from "@/types/inspection";
import { createContext, Dispatch, SetStateAction } from "react";

export interface InspectionOrderContextType {
  order: InspectionOrder;
  items: InspectionOrderItem[];
  setItems: Dispatch<SetStateAction<InspectionOrderItem[]>>;
  progress: InspectionProgress | null;
  setProgress: Dispatch<SetStateAction<InspectionProgress | null>>
};

export const InspectionOrderContext = createContext<InspectionOrderContextType>({
  order: {} as InspectionOrder,
  items: [],
  setItems: () => { },
  progress: null,
  setProgress: () => { }
});